// extracted by mini-css-extract-plugin
export default {"container":"alert-modal_container__qz86p","ctas":"alert-modal_ctas__LA821"};